import React from "react"
import { useSelector } from "react-redux"
import { Navigate, useLocation } from "react-router-dom"
import { userSelector } from "appRedux/selectors/user"
import { PermissionAction } from "utils/permissionConfig"
import { hasPermission } from "utils/permissions"

interface IProps {
    children: React.ReactNode
    permittedRoles?: string[]
    permission?: string
    permissionAction?: PermissionAction
    authorized: boolean
}

export const ProtectedRoute: React.FC<IProps> = ({
    children,
    permittedRoles,
    authorized,
    permission,
    permissionAction = "view",
}) => {
    const user = useSelector(userSelector)
    const role = (user?.admin ?? user?.role ?? "user") as string
    const location = useLocation()

    const hasRoutePermission =
        !permission || hasPermission(user, permission, permissionAction)

    const hasRequiredRole =
        !permittedRoles ||
        permittedRoles.length === 0 ||
        permittedRoles.includes(role) ||
        role === "super_admin"

    if (!authorized) {
        return (
            <Navigate to="/login" replace state={{ from: location }} />
        )
    }

    if (!hasRoutePermission || !hasRequiredRole) {
        return (
            <Navigate to="/not-authorized" replace state={{ from: location }} />
        )
    }

    return <>{children}</>
}
